
import { defineComponent, reactive, Ref, ref, ComputedRef, computed, toRefs, onMounted, watch, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import {UploadOutlined} from '@ant-design/icons-vue'


import { Props, validateInfos } from 'ant-design-vue/lib/form/useForm'
import { message, Form } from 'ant-design-vue'
const useForm = Form.useForm
import useI18nAntdFormVaildateInfos from '@/composables/useI18nAntdFormVaildateInfos'
import dayjs, {Dayjs} from 'dayjs'

import {UploadBankDatApi} from './data.d'

import {StateType as UploadStateType} from '@/store/upload'
import {StateType as UserStateType} from '@/store/user'
import {StateType as UploadBankStateType} from './store'
import {StateType as AccountInfoStateType} from '../../../store'
import {ImageUrlParams} from '@/services/data.d'

import {beforeUploadTypeSize} from '@/utils/upload'

interface UploadBankSetupData {
    modelRef: UploadBankDatApi;
    validateInfos: ComputedRef<validateInfos>;
    imageUrl: Ref<string>;
    usermsg: ComputedRef<object>;
    infoData: any;
    typeStr: any;
    errmsg: Ref<any[]>;
    isOne: Ref<boolean>;
    disabledDate: any;
    handleCtrl: (e: MouseEvent) => void;
    handleSubmit: (e: MouseEvent) => void;
    handleUpload: (info: any) => void;
    beforeUpload:(info: any) => void;
    changeTxt: (v: string | number) => string;
}

export default defineComponent({
    name: 'UploadBank',
    components: {
        UploadOutlined
    },
    props: {
        infoData: {
            type: Object,
            default: ()=>{{}}
        },
        typeStr: String
    },
    emits: ['update:visible','hidden'],
    setup(props,{emit}):UploadBankSetupData {
        const store = useStore<{
            upload:UploadStateType,
            uploadbank:UploadBankStateType,
            accountquery:AccountInfoStateType,
            user: UserStateType
        }>()
        const imageUrl = ref<string>('')
        const userMsg = JSON.parse(String(localStorage.getItem('userMsg'))) || {}
        const info = ref<any>({})
        const {infoData,typeStr} = toRefs(props)
        const errmsg = ref<any[]>([])
        const isOne = ref<boolean>(false)
        const {userType,userEnterprise,userExtend} = store.state.user.currentUser
        const name = userType == 1 ? (userExtend&&userExtend.nameCn||''):(userEnterprise&&userEnterprise.enterpriseName||'')
        const bankname = userType == 1 ? (userExtend&&userExtend.bankName||''):(userEnterprise&&userEnterprise.bankName||'')
        const bankid = userType == 1 ? (userExtend&&userExtend.bankId||''):(userEnterprise&&userEnterprise.bankId||'')
        const modelRef = reactive<UploadBankDatApi>({
            currency: typeStr.value ==='add' ? 1 : infoData.value.currency, //币种
            remittanceTime: typeStr.value ==='add' ? '' : infoData.value.remittanceTime, //付款时间
            paymentAccount: typeStr.value ==='add' ? name : infoData.value.paymentAccount, //付款方名称
            paymentAccountBank:typeStr.value ==='add' ? bankname: infoData.value.paymentAccountBank, //银行名称
            paymentAccountNo: typeStr.value ==='add' ? bankid : infoData.value.paymentAccountNo, //付款账号
            rechargeAmount: typeStr.value ==='add' ? null : infoData.value.rechargeAmount, //付款金额
            voucherFileId: typeStr.value ==='add' ? '' : infoData.value.fileId, //凭证文件上传ID
        })
        const rulesRef = reactive({
            paymentAccount: [
                {
                    required: true,
                    message: '请输入付款方名称'
                },
            ],
            paymentAccountBank:[
                {
                    required: true,
                    message: '请输入付款银行名称'
                },
            ],
            paymentAccountNo: [
                {
                    required: true,
                    message: '请输入付款银行账号'
                },
            ],
            remittanceTime: [
                {
                    required: true,
                    message: '请选择汇款日期'
                },
            ],
            rechargeAmount: [
                {
                    required: true,
                    validator: (rule:any,value:string,callback:any) => {
                        if(value==''||value==undefined){
                            return Promise.reject('请输入金额')
                        }else if(parseInt(value) <=0  ){
                            return Promise.reject('只能输入大于0的整数')
                        }else{
                            return Promise.resolve()
                        }
                    }
                },
            ],
            currency: [
                {
                    required: true,
                    message: '请选择币种'
                },
            ],
            voucherFileId: [
                {
                    required: true,
                    message: '请上传银行凭证'
                },
            ]
        })
        console.log('infoData', infoData.value);
        const { validate, validateInfos } = useForm(modelRef,rulesRef)
        const validateInfosNew = useI18nAntdFormVaildateInfos(validateInfos)
        const handleSubmit = async(e: MouseEvent) => {
            e.preventDefault()
            isOne.value = true
            try {
                info.value = store.state.accountquery.accountinfo
                const fieldsValue = await validate<UploadBankDatApi>()
                fieldsValue.remittanceTime = fieldsValue.remittanceTime&&dayjs(fieldsValue.remittanceTime).format('YYYY-MM-DD HH:mm:ss') || ''
                fieldsValue['userCode'] = info.value.userCode
                fieldsValue['userType'] = info.value.userType
                fieldsValue['accountType'] = info.value.accountType
                typeStr.value == 'add' ? fieldsValue : fieldsValue['rechargeFlowCode'] = infoData.value.rechargeFlowCode
                const res: boolean = await store.dispatch('uploadbank/uploadBankVoucherInfoFn', fieldsValue)
                if(res===true){
                    emit('update:visible',false)
                    emit('hidden', 'updateY')
                }else{
                    isOne.value = false
                }
            } catch (error) {
                isOne.value = false
                console.log('error', error);
            }
        }

        //上传图片
        const handleUpload = (info: any) => {
            const formdata = new FormData()
            formdata.append('file', info.file)
            formdata.append('fileType', '6')
            uploadImg(formdata)
        }

        //上传前图片类型大小限制
        const beforeUpload = (info:any) => {
            return beforeUploadTypeSize(info)
        }

        //上传图片
        const uploadImg = async(params:any,type:string='') => {
            try {
                const res:boolean = await store.dispatch('upload/uploadFileFn',params)
                if(res === true){
                    modelRef.voucherFileId = store.state.upload.uploadRes.id
                    const data = {id: store.state.upload.uploadRes.id}
                    imageUrlRes(data,type)
                }
            } catch (error) {
                message.warning('上传失败!')
            }
        }
        //获取返回的图片地址
        const imageUrlRes = async(params:ImageUrlParams,type:string='') => {
            try {
                const res:boolean = await store.dispatch('upload/getImgUrlFn',params)
                if(res === true){
                    imageUrl.value = store.state.upload.imageUrlRes.fileUrl
                }
            } catch (error) {
                message.warning('图片获取失败!')
            }
        }

        //取消弹框
        const handleCtrl = (e: MouseEvent) => {
            emit('update:visible',false)
        }

        const usermsg = computed<object>(() => {
            const msg = {
                userCode: userMsg.userCode,
                userType: userMsg.userType == 1 ? '预付账户' : '账期账户',
                userName: userMsg.userName
            }
            return msg || {}
        })

        const changeTxt = (v: string | number) => {
            const obj = {
                1: '待审核',
                2: '审核通过',
                3: '审核驳回'
            }
            return obj[v] || v
        }

        //时间选择
        const disabledDate = (current: Dayjs) => {
            return current && (current > dayjs().endOf('day'))
        }

        //审核驳回错误提示
        const returnError = (o:any) => {
            errmsg.value = []
            const remark = o&&JSON.parse(String(o)) || {}
            o&&Object.keys(remark).forEach((item:any, index: number) => {
            errmsg.value.push({
                    id: index,
                    msg: remark[item].includes(':')&&remark[item].split(':')[1]||remark[item]
                })
            })
        }

        //监听
        watch(()=>infoData.value,(nv,ov)=>{
            infoData.value = nv
            returnError(nv.remarks)
        })

        onMounted(() => {
            infoData.value.fileId&&typeStr.value!=='add'?imageUrlRes({id: infoData.value.fileId}):imageUrl.value=''
            returnError(infoData.value.remarks)
        })


        return {
            errmsg,
            infoData,
            typeStr,
            modelRef,
            validateInfos: validateInfosNew,
            usermsg,
            imageUrl,
            isOne,
            handleCtrl,
            handleSubmit,
            handleUpload,
            beforeUpload,
            changeTxt,
            disabledDate
        }
    }
})
